/** Fornitori: ricerca nell'anagrafica letta dal VendorHub (sola lettura), porta alla scheda. */
import { Input, Table } from "antd";
import { useState } from "react";
import { Link } from "react-router-dom";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import type { FornitoreBreveDto } from "@qa/shared";
import { api } from "../../api/client";
import { messaggioErrore } from "../../i18n/errori";
import { PageHead, Ro } from "../../components/ui";

export default function FornitoriPage() {
  const { t } = useTranslation();
  const [q, setQ] = useState("");
  const r = useQuery({ queryKey: ["fornitori", "elenco", q], queryFn: () => api.get<FornitoreBreveDto[]>("/fornitori", { q: q || undefined, limit: 100 }), placeholderData: keepPreviousData });
  return (
    <>
      <PageHead
        crumbs={[{ label: t("portale.nome"), to: "/" }, { label: t("menu.gruppoClaim"), to: "/claim" }, { label: t("menu.fornitori") }]}
        title={t("claim.fornitore.elencoTitolo")}
        sub={t("claim.fornitore.elencoSottotitolo")}
        extra={<Ro>{t("claim.fornitore.anagraficaRo")}</Ro>}
      />
      <Input.Search allowClear placeholder={t("claim.fornitore.cerca")} aria-label={t("claim.fornitore.cerca")} onSearch={(v) => setQ(v.trim())} style={{ width: 320, marginBottom: 14 }} />
      <Table<FornitoreBreveDto>
        rowKey="id"
        size="middle"
        loading={r.isFetching}
        dataSource={r.data ?? []}
        pagination={{ pageSize: 50, hideOnSinglePage: true, showSizeChanger: false }}
        locale={{ emptyText: r.isError ? messaggioErrore(r.error) : t("claim.fornitore.vuoto") }}
        columns={[
          { title: t("claim.fornitore.nome"), key: "n", render: (_, f) => <Link to={`/fornitori/${f.id}`}>{f.nome}</Link> },
          { title: t("claim.fornitore.codice"), key: "c", render: (_, f) => <span className="mono">{f.codice ?? "—"}</span> },
          { title: t("claim.fornitore.paese"), key: "p", render: (_, f) => f.paese ?? "—" },
        ]}
      />
    </>
  );
}
